import recaptchaService from '@/services/recaptcha.service'
// import { useAuthStore } from '@/stores/auth.store'
import { useEmbedConfigureStore, type IInputFiles } from '@/stores/embeds/embedConfigure.store'
import { useIdeStore } from '@/stores/embeds/ide.store'
import { FILE_MESSAGE_TYPE } from '@/utils/embeds/ide'

import axios from 'axios'
import { cloneDeep } from 'lodash-es'

// import axios from 'axios'
let controller: AbortController | null = null
export interface IPluginFileUploadRequest {
  projectKey: number
  content: any
  name: string
  clientId: string
}
export interface IFileUploadResponse {
  inputFiles: Array<string>
}
export interface IFileRemoveRequest {
  projectKey: number
  name: string
}
export interface IInitIdeResponse {
  inputFiles: Array<string>
  robotChecked: boolean
}
/**
 * Get temp files from backend
 * @returns - promise
 */
const UpdateInputFiles = async () => {
  useIdeStore().setInputFilesUpdated(true)
  await axios.post('/api/doodle/initIde').then((response: { data: IInitIdeResponse }) => {
    const newInputFiles: IInputFiles[] = response.data.inputFiles.map((file: any) => {
      return { path: file }
    })
    const defaultInputFiles: IInputFiles[] = cloneDeep(useIdeStore().inputFiles) || []
    // filter and get inputfiles not on defaultInputFiles
    const diferentFiles: IInputFiles[] = newInputFiles.filter(
      (file) => !defaultInputFiles.find((f) => f.path === file.path)
    )
    useIdeStore().setInputFiles([...defaultInputFiles, ...diferentFiles])
  })
}
/**
 * Get default files
 * @param embedKey - The embed key
 * @returns - promise
 */
const UpdateDefaultInputFiles = async (embedKey: string) => {
  const payload = {
    embedKey
  }
  await axios.post('/api/embed/getInputFilesByEmbedKey', payload).then((response) => {
    const defaultServerInputFiles: IInputFiles[] = response.data.map((file: any) => {
      return { path: file.name }
    })
    if (useEmbedConfigureStore().getEmbedConfig?.inputFiles) {
      useEmbedConfigureStore().getEmbedConfig!.inputFiles! = []
      defaultServerInputFiles.forEach((file: any) => {
        useEmbedConfigureStore().getEmbedConfig!.inputFiles!.push({ path: file.path })
        useIdeStore().setInputFiles(
          cloneDeep(useEmbedConfigureStore().getEmbedConfig!.inputFiles) || []
        )
      })
    }
  })
}
/**
 *  Try upload file
 * @param event - The event
 * @param embedId - The embed id
 * @returns - promise
 */
const tryUploadFile = async (
  event: Event & { dataTransfer?: DataTransfer },
  embedId: string | null = null
) => {
  return await recaptchaService
    .callViaCaptcha()
    .then(async () => {
      const inputElement =
        event.type === 'change' ? (event.target as HTMLInputElement) : event.dataTransfer
      const inputFilesCount = useEmbedConfigureStore().getEmbedConfig?.inputFiles.length || 0
      if (inputFilesCount >= useIdeStore().isMaxUploads) {
        useIdeStore().setFileUploadMessages(
          FILE_MESSAGE_TYPE.ERROR,
          'Maximum upload limit reached.'
        )
      }
      if (inputElement?.files && inputElement.files[0].size >= useIdeStore().isMaxFileSize) {
        useIdeStore().setFileUploadMessages(FILE_MESSAGE_TYPE.ERROR, 'File size limit exceeded.')
      }

      if (!inputElement?.files || !inputElement.files[0]) return

      controller = new AbortController()
      const formData = new FormData()
      if (embedId == null || !useEmbedConfigureStore().getOnEditMode)
        formData.append('projectKey', '1001')
      formData.append('file', inputElement?.files[0])

      let url = ''
      if (embedId && useEmbedConfigureStore().getOnEditMode) {
        url = `/api/embed/uploadInputFile?embedId=${embedId}`
      } else {
        url = '/api/projectSync/uploadInputFile'
      }

      useIdeStore().setUploadInProgress(true)
      return await axios
        .post(url, formData, {
          signal: controller?.signal,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response: any) => {
          useIdeStore().setFileUploadMessages(
            FILE_MESSAGE_TYPE.SUCCESS,
            'File uploaded successfully.'
          )
          useIdeStore().setUploadInProgress(false)
          if (embedId && useEmbedConfigureStore().getOnEditMode) {
            return { path: response?.data?.name }
          } else {
            return {
              path: (event.target as HTMLInputElement).files![0].name
            }
          }
        })
        .catch((error) => {
          useIdeStore().setFileUploadMessages(
            FILE_MESSAGE_TYPE.ERROR,
            error?.response?.data?.errors[0] || 'Unable to upload file.'
          )
          useIdeStore().setUploadInProgress(false)
        })
    })
    .catch((error: any) => {
      useIdeStore().setFileUploadMessages(
        FILE_MESSAGE_TYPE.ERROR,
        error.message || 'Failed to verify captcha'
      )
    })
}
/**
 * Cancel upload
 */
const cancelUpload = () => {
  if (controller) controller?.abort()
  controller = null
  useIdeStore().setFileUploadMessages(FILE_MESSAGE_TYPE.INFO, 'Upload Canceled.')
  useIdeStore().setUploadInProgress(false)
}
/**
 * Remove file
 * @param file - The file to remove
 * @returns - promise
 */
const removeFile = async (file: IInputFiles) => {
  const fileRemoveRequest: IFileRemoveRequest = {
    projectKey: 1001,
    name: file.path
  }
  await axios
    .post('/api/projectSync/deleteInputFile', fileRemoveRequest)
    .then(() => {
      useIdeStore().setFileUploadMessages(
        FILE_MESSAGE_TYPE.SUCCESS,
        `File ${file.path} removed successfully.`
      )
      return file
    })
    .catch(() => {
      useIdeStore().setFileUploadMessages(
        FILE_MESSAGE_TYPE.ERROR,
        `Unable to remove file ${file.path}.`
      )
      throw new Error(`Unable to remove file ${file.path}.`)
    })
}

export default {
  UpdateInputFiles,
  UpdateDefaultInputFiles,
  tryUploadFile,
  cancelUpload,
  removeFile
}
